<div class="modal-header">
  <div class="font-xl fw-bold text-center">
    <span *ngIf="da.id" [translate]="'modal.deliveryAddress.editDeliveryAddress'"></span>
    <span *ngIf="!da.id" [translate]="'modal.deliveryAddress.newDeliveryAddress'"></span>
    <i class="icon-close" (click)="modal.dismiss()"></i>
  </div>
</div>
<div class="modal-body"
     [ngBusy]="{busy: saving, message: ('common.pleaseWait' | translate)}">
  <form #deliveryAddressForm="ngForm">
    <div class="form-group">
      <label class="font-xl fw-bold" [translate]="'common.country'">Country</label>
      <ui-select
        [placeholder]="'orderProcess.payment.invoiceCompanySearcher.selectCountry' | translate"
        [extraClasses]="'w-100'"
        [items]="countryCodeItems"
        [(model)]="countryCodeItem"
        (modelChange)="onCountryChange($event)">
      </ui-select>
    </div>

    <div class="form-group">
      <label class="font-xl fw-bold"
             [translate]="'orderProcess.delivery.deliveryForms.recipientName'">Recipients name</label>
      <input class="form-control"
             placeholder="{{'common.name' | translate}}"
             name="recipientsName"
             [maxlength]="32"
             [disabled]="!da.country"
             [(ngModel)]="da.recipient"
             required>
    </div>

    <div class="form-group">
      <label class="font-xl fw-bold" [translate]="'common.address'">Address</label>
      <input class="form-control"
             placeholder="{{'common.streetName' | translate}}"
             name="streetName"
             [maxlength]="256"
             [disabled]="!da.country"
             [(ngModel)]="da.address"
             required>
    </div>

    <div class="form-group">
      <div class="row">
        <div class="col-5 col-sm-4">
          <label class="font-xl fw-bold" [translate]="'common.postNumber'">Post code</label>
          <ui-input-loader-wrap [loading]="busy">
            <input class="form-control"
                   placeholder="{{'common.postNumberPlaceholder_' + da.country | translate}}"
                   name="postalCode"
                   [inputMaskArgs]="{countryCode: da.country}"
                   [inputMask]="'postNumber'"
                   [disabled]="!da.country"
                   [(ngModel)]="da.postNumber"
                   (ngModelChange)="cityNotFound=false; onPostNumberUpdated$.next($event)"
                   required>
          </ui-input-loader-wrap>
        </div>
        <div class="col-7 col-sm-8">
          <label class="font-xl fw-bold" [translate]="'common.postalArea'">City</label>
          <input class="form-control"
                 placeholder="{{'common.postalArea' | translate}}"
                 name="city"
                 disabled
                 [(ngModel)]="da.cityName"
                 required>
        </div>
      </div>
    </div>

    <ui-message class="d-block mb-2" [type]="'error'" *ngIf="cityNotFound">
      {{'common.notFound' | translate}}
    </ui-message>

    <div class="form-group">
      <label class="font-xl fw-bold"
             [translate]="'modal.deliveryAddress.contactPersonPhoneNumber'">
        Contact person phone number
      </label>
      <input class="form-control"
             placeholder="{{'profile.myAccount.phone' | translate}}"
             name="phone"
             [inputMask]="'phone'"
             [disabled]="!da.country"
             [(ngModel)]="da.phone"
             required>
    </div>

    <div class="form-group">
      <label class="font-xl fw-bold" [translate]="'modal.deliveryAddress.instructionsToDriver'">
        Instructions to driver
      </label>
      <textarea class="form-control" rows="3"
                name="note"
                [maxlength]="512"
                placeholder="{{'modal.deliveryAddress.instructions' | translate}}"
                [disabled]="!da.country"
                [(ngModel)]="da.note"></textarea>
    </div>

    <div class="text-end">
      <button class="btn btn-pink pe-5 ps-5"
              [translate]="'common.save'"
              [disabled]="deliveryAddressForm.invalid || !da.country || !da.cityName"
              (click)="addDeliveryAddress()">Save
      </button>
    </div>
  </form>

</div>
